import { Alert, IconButton, Typography } from "@mui/material"
import { MdMyLocation } from "react-icons/md"

/**
 * Cidade/UF à esquerda e distância à direita — mesmo Alert informativo (lista e detalhes).
 * Distância calculada no PHP (mobileNovo1 / GestaoVagasGeo).
 */
export default function GestaoVagaCidadeDistancia({
	cidadeEstado = "",
	distanciaTexto = "",
	className = "",
	onAtualizarLocalizacao,
	atualizandoLocalizacao = false,
}) {
	const cidade = String(cidadeEstado || "").trim()
	const distancia = String(distanciaTexto || "").trim()

	if (!cidade && !distancia) {
		return null
	}

	return (
		<Alert
			severity="info"
			className={`gv-alert-linha-toda gv-cidade-distancia-alert ${className}`.trim()}
		>
			<div className="gv-cidade-distancia">
				<div className="gv-cidade-distancia__cidade">
					{cidade ? (
						<>
							<Typography
								variant="caption"
								color="text.secondary"
								display="block"
								className="gv-cidade-distancia__rotulo"
							>
								Cidade / UF
							</Typography>
							<Typography variant="body2" component="span" className="font-medium">
								{cidade}
							</Typography>
						</>
					) : (
						<Typography variant="body2" color="text.secondary">
							Local da vaga
						</Typography>
					)}
				</div>
				{distancia || onAtualizarLocalizacao ? (
					<div className="gv-cidade-distancia__dist-wrap">
						{distancia ? (
							<Typography
								variant="body2"
								component="span"
								className="gv-cidade-distancia__km"
							>
								{distancia}
							</Typography>
						) : null}
						{onAtualizarLocalizacao ? (
							<IconButton
								type="button"
								size="small"
								className="gv-cidade-distancia__atualizar-geo"
								aria-label="Atualizar minha localização"
								title="Atualizar localização"
								disabled={atualizandoLocalizacao}
								onClick={onAtualizarLocalizacao}
							>
								<MdMyLocation size={20} />
							</IconButton>
						) : null}
					</div>
				) : null}
			</div>
		</Alert>
	)
}
